import { render, staticRenderFns } from "./jump.vue?vue&type=template&id=65084e92&scoped=true&"
import script from "./jump.vue?vue&type=script&lang=js&"
export * from "./jump.vue?vue&type=script&lang=js&"
import style0 from "./jump.vue?vue&type=style&index=0&id=65084e92&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65084e92",
  null
  
)

export default component.exports